import { ButtonLink } from '@lightspeed/design-system-react'
import React from 'react'

type Props = {
  message: string
  linkMessage?: string
}
/**
 * The toast component for special order product notification
 * Need to be a component cause it needs to render a Link inside the toast message
 */
export const SpecialOrderProductToast = (props: Props) => {
  const { message, linkMessage } = props
  return (
    <>
      {message}
      {linkMessage && (
        <>
          {' '}
          <ButtonLink
            href="/inventory/special-orders"
            className="special-order-product-toast"
            link={true}
          >
            {linkMessage}
          </ButtonLink>
        </>
      )}
    </>
  )
}
